import { action, computed, makeAutoObservable, runInAction } from "mobx"
import moment from "moment";
import { PaymentProviderType } from "../../../../../services/general/models";
import { ExecutionStatus } from "../../../../../services/general/requestsResponses"
import {  OrderStatus } from "../../../../../services/orders/models";
import { Menu } from "../../../../../services/menu/models";
import { getBookingMenus, getMenus } from "../../../../../services/menu";
import {
    cancelBookingOrder,
    getBookingOrder,
    getBookingOrders,
    getBookings
} from "../../../../../services/bookingOrders";
import { Booking, BookingOrder } from "../../../../../services/bookingOrders/models";
import { IGetBookingOrderRequest } from "../../../../../services/bookingOrders/requestsResponses";


interface IBookingFilter {
    createdAfter: Date;
    createdBefore: Date;
    isPaid: boolean | null;
    paymentTypes: PaymentProviderType[];
    statuses: OrderStatus[];
    limit: number;
    skip: number;
    menusIds: number[],
    clientsIds: number[]
}

class BookingsStore {

    list: BookingOrder [] = [];
    isLoaded: boolean = false;
    currentOrder?: BookingOrder;
    menusList: Menu[] = [];
    bookings: Booking[] = [];

    showDetailsForm: {
        currentOrder?: BookingOrder,
        isFormOpen: boolean
    } = {
        isFormOpen: false
    };

    filter: IBookingFilter = {
        createdAfter: moment().startOf("day").toDate(),
        createdBefore: moment().endOf("day").toDate(),
        isPaid: null,
        paymentTypes: [
            PaymentProviderType.cloudpayments,
            PaymentProviderType.companyInvoice,
            PaymentProviderType.offline,
            PaymentProviderType.toBankCard,
            PaymentProviderType.sbpTochka
        ],
        statuses: [
            OrderStatus.paid,
            OrderStatus.accepted,
            OrderStatus.acceptedByKitchen,
            OrderStatus.canceled,
            OrderStatus.canceledWithRefund,
            OrderStatus.canceledByKitchen,
            OrderStatus.finished,
            OrderStatus.givenOut,
            OrderStatus.givenOutToDelivery,
            OrderStatus.new,
            OrderStatus.ready,
            OrderStatus.readyToPickUp,
            OrderStatus.sentToKitchen,
        ],
        limit: 200,
        skip: 0,
        menusIds: [],
        clientsIds: []
    }

    constructor() {
        makeAutoObservable(this)
    }


    async init() {
        const menusResponse = await getBookingMenus();
        runInAction(() => {
            this.menusList = menusResponse.menus;
            if (this.menusList.length !== 0 && this.filter.menusIds.length === 0) {
                this.filter.menusIds = [this.menusList[0].id];
            }
        });
    }

    getMenuById(menuId: number): Menu | undefined {
        return this.menusList.find(item => item.id === menuId);
    }

    async getBookings(data) {
        const getOrdersResponse = await getBookingOrders(data);
        runInAction(() => {
            this.list = getOrdersResponse.orders;
            this.isLoaded = true;
        });
    }

    async loadBookingItems(){
        const res = await getBookings({
            bookingsOrderIds: [this.currentOrder.id],
            statuses:[],
            fromDate: null,
            toDate: null,
            menuId: this.currentOrder.menuBookingId
        });
        runInAction(() => {
            this.bookings = res.bookings || [];
        })
    }

    async getBooking(data: IGetBookingOrderRequest) {
        const getOrderResponse = await getBookingOrder(data);
        runInAction(() => {
            this.currentOrder = getOrderResponse.order;
            this.isLoaded = true;
        });
        await this.loadBookingItems()
    }



    async returnPayment(data) {
        const res = await cancelBookingOrder(data);
        runInAction(() => {
            if (this.currentOrder) {
                this.currentOrder.paymentDetails.isPaid = false;
            }
        });
        return res.executionStatus === ExecutionStatus.Finished;

    }

    async ensureOrdersLoaded(filter: IBookingFilter) {
        if (!this.isLoaded) {
            const response = await getBookingOrders(filter);
            runInAction(() => {
                this.filter = filter;
                this.list = response.orders
                this.isLoaded = true;
            })
        }
    }


    async reloadOrders() {
        runInAction(() => {
            this.isLoaded = false;
        })
        await this.ensureOrdersLoaded(this.filter);
    }


    @action
    openForm(current?: BookingOrder) {
        this.showDetailsForm.isFormOpen = true;
        this.showDetailsForm.currentOrder = current;
    }

    @action
    closeForm() {
        this.showDetailsForm.isFormOpen = false;
        this.showDetailsForm.currentOrder = undefined;
    }

    @action
    setBookingsFilter(filter: IBookingFilter) {
        this.filter = filter;
    }

    @computed
    getBookingById(bookingId: number) {
        return this.list.find(item => item.id === bookingId);
    }

}


export default BookingsStore
